import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { mapDispatchToProps } from "../../../store/helpers/mapDispatch";
import { mapStateToProps } from "../../../store/helpers/mapState";
import MinutesListComponent from "../../../components/Meetings/Minutes";

const MinutesManagement = (props) => {
  const {
    selectedFolder,
    GetAllMeetings,
    meetings,
    location,
    loggedUser,
    GetAllInvitedIn,
    invitedIn,
    settings,
    MarkAsRead,
    systemSettings
  } = props;
  const [notificationList, setNotificationsList] = useState([]);

  useEffect(() => GetAllMeetings("All"), [GetAllMeetings]);
  useEffect(() => GetAllInvitedIn("All"), [GetAllInvitedIn]);

  return (
    <div className="w-full mb-12 px-4">
      <MinutesListComponent
        selectedFolder={selectedFolder}
        meetings={meetings}
        GetAllMeetings={GetAllMeetings}
        GetAllInvitedIn={GetAllInvitedIn}
        location={location}
        loggedUser={loggedUser}
        invitedIn={invitedIn}
        settings={settings}
        notification={notificationList}
        MarkAsRead={MarkAsRead}
        systemSettings={systemSettings}
      />
     </div>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(MinutesManagement);
